import { useRequest } from 'alova';

import { alovaInstanceAuth } from './alovaInstanceOnboarding';

import { ApiAuthResponse, User } from './types';

const useApiAuth = () => {
  const apiAuthCustomer = useRequest(alovaInstanceAuth.Get<ApiAuthResponse<User>>('/v1/app/customer'), { immediate: false });

  const apiAuthLogout = useRequest(alovaInstanceAuth.Post('v1/app/logout'), { immediate: false });

  return {
    apiAuthCustomer,
    apiAuthLogout,
  };
};

export default useApiAuth;
